const removeExcessCharacters = str => {
  return str.replace(/( |\\n|\\r|\\t|\t|\n|\r)+/g, ' ').trim();
};
export default removeExcessCharacters;
